import "./migrationNotice.css";

export default function MigrationNotice() {
  return (
    <div className="migration">
      <div className="migration__atmosphere" aria-hidden="true" />

      <header className="migration__header">
        <p className="migration__brand">Forests to Fortune | Las Azucenas</p>
      </header>

      <main className="migration__main">
        <section className="migration__hero">
          <h1 className="migration__headline">
            Tree ownership management has moved to Canopy Marketplace
          </h1>
          <p className="migration__lede">
            Forests to Fortune | Las Azucenas has partnered with{" "}
            <a
              href="https://www.canopy.market/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Canopy Marketplace
            </a>{" "}
            for tree ownership management.
          </p>
          <p className="migration__access">
            Please reach out to{" "}
            <a href="mailto:alain@foreststofortune.org">
              alain@foreststofortune.org
            </a>{" "}
            to get access to your new Canopy Marketplace account.
          </p>
          <div className="migration__actions">
            <a
              className="migration__cta"
              href="https://www.canopy.market/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Visit Canopy Marketplace
            </a>
            <a
              className="migration__cta migration__cta--ghost"
              href="mailto:alain@foreststofortune.org"
            >
              Request account access
            </a>
          </div>
        </section>

        <section className="migration__about" aria-labelledby="about-canopy">
          <img
            className="migration__canopy-logo"
            src="/canopy-logo.svg"
            alt="Canopy Marketplace"
            width="280"
            height="70"
          />
          <h2 id="about-canopy">
            The online marketplace for buying &amp; selling trees
          </h2>
          <p>
            Canopy Marketplace is where you browse, buy, sell, and manage your
            trees—with documented ownership, growth tracking, and a mobile app
            for access on the go. Forests are reviewed and certified before they
            appear on the marketplace.
          </p>
        </section>
      </main>

      <footer className="migration__footer">
        <p>
          Questions? Email{" "}
          <a href="mailto:alain@foreststofortune.org">
            alain@foreststofortune.org
          </a>
        </p>
        <p>
          <a
            href="https://www.canopy.market/"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.canopy.market
          </a>
        </p>
      </footer>
    </div>
  );
}
